import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, ElementRef, Inject } from '@angular/core';

@Component({
    selector: 'list-info',
    templateUrl: './list-info.component.html',
})
export class ListInfoComponent {

    public title: string;
    public message: string[];
    public customClass: string = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<ListInfoComponent>,
        public element: ElementRef,
    ) {
        if (data && data.customClass) {
            this.customClass = data.customClass;
        }
    }

    public dispose() {
        this.dialogRef.close();
    }
}
